import React from "react";
import { useModalUploadFileState } from "../../states/useStates";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function ModalFileUpload({
  title,
  openActionLabel,
  bodyContent,
  submitActionLabel,
  onSubmit,
  files,
}) {
  const [showModal, setShowModal] = useModalUploadFileState(false);

  const isDisabled = !files || files.length === 0;

  return (
    <>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger>
            <button
              className="border border-primary rounded text-primary hover:text-white active:bg-primary p-3 hover:bg-primary  shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150"
              type="button"
              onClick={() => setShowModal(true)}
            >
              {openActionLabel}
            </button>
          </TooltipTrigger>
          <TooltipContent>
            <p className="text-xs">Add new Files</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>

      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none ">
            <div className="relative w-auto my-6 mx-auto min-w-[40rem] max-w-5xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                  <h3 className="text-3xl font-semibold">{title}</h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setShowModal(false)}
                  >
                    <span className="bg-transparent hover:text-black/40 text-black h-6 w-6 text-2xl block outline-none focus:outline-none">
                      ×
                    </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-6 flex-auto">
                  <div className="my-2 text-blueGray-500 text-lg leading-relaxed">
                    {bodyContent}
                  </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                  <button
                    className="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                  {isDisabled ? (
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <span>
                            <button
                              className="font-bold uppercase text-sm px-6 py-3 rounded shadow outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 bg-gray-300 text-gray-500 cursor-not-allowed"
                              type="button"
                              disabled
                            >
                              {submitActionLabel}
                            </button>
                          </span>
                        </TooltipTrigger>
                        <TooltipContent>
                          <p className="text-xs">
                            Upload at least one file to enable upload
                          </p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  ) : (
                    <button
                      className="font-bold uppercase text-sm px-6 py-3 rounded shadow outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 bg-primary hover:bg-primary/80 text-white active:bg-emerald-600 hover:shadow-lg"
                      type="button"
                      onClick={() => {
                        onSubmit();
                        setShowModal(false);
                      }}
                    >
                      {submitActionLabel}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
